import { Col, Image, Input, Select } from "antd";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BUTTON_SIZE, INPUT_SIZE } from "../../common/ThemeConstants";
import BasicFormComponent from "../../components/formComponent/BasicFormComponent";
import FormCheckbox from "../../components/general/FormCheckbox";
import FormSelect from "../../components/general/FormSelect";
import FormTextField from "../../components/general/FormTextField";
import ProductDetailsManager from "./components/ProductDetailsManager";
import {
  deleteRow,
  resetState,
  setFormFieldValue,
  setInitialState,
  setSearchFieldValue,
  submitForm,
} from "../../redux/actions/basicFormAction";
import {
  SET_SUPPORTING_TABLE,
  UPDATE_FORM_FIELD,
} from "../../redux/reduxConstants";

const initialFormValues = {
  ProductId: null,
  ProductCategoryId: null,
  ProductName: "",
  DisplayInPos: true,
  DisplayInWeb: true,
  DisplayInOdms: false,
  DisplayInMobile: true,
  IsDeal: false,
  ProductImage: "",
  IsExpiryMandatory: false,
  Description: "",
  ProductTagId: null,
  IsEnable: true,
  IsDealPackage: false,
  ProductSecondaryCategoryStr: "",
  ProductDetail: [],
  ProductDetailBranch: [],
  ProductDetailOrderSource: [],
};

const initialSearchValues = {
  ProductId: null,
  ProductName: "",
  ProductCategoryId: null,
  ProductDetail: [],
  ProductDetailBranch: [],
  ProductDetailOrderSource: [],
};

const columns = [
  {
    title: "Product Name",
    dataIndex: "ProductName",
    key: "ProductName",
  },
  {
    title: "Product Category",
    dataIndex: "ProductCategoryName",
    key: "Category Name",
  },
  {
    title: "Image",
    key: "image",
    render: (_, record) => (
      <Image
        src={process.env.REACT_APP_BASEURL + record.ProductImage}
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "8px",
          objectFit: "cover",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)" // soft shadow
        }}

      />
    ),
  },
];

const CreateProduct = () => {
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [updateId, setUpdateId] = useState(null);

  // create a varaible to hold the product which we are going to edit
  const [editProduct, setEditProduct] = useState(null);
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);
  const [isProductUpdate, setIsProductUpdate] = useState(false);
  const [lastCreatedProduct, setLastCreatedProduct] = useState(null);
  const [resetDetailsTrigger, setResetDetailsTrigger] = useState(0);
  let selectedImgUrl = "";
  const { TextArea } = Input;

  const {
    formFields,
    searchFields,
    itemList,
    formLoading,
    tableLoading,
    supportingTable,
  } = useSelector((state) => state.basicFormReducer);



  console.log("checking supporting table and items list ", supportingTable, itemList)






  useEffect(() => {
    const payload = {
      OperationId: 1,
      CompanyId: userData.CompanyId,
      UserId: userData.UserId,
      UserIP: "12.1.1.12",
      ...initialFormValues,
    };

    dispatch(
      setInitialState(
        "/CrudProductMaster",
        payload, // send as JSON, not FormData
        initialFormValues,
        initialSearchValues,
        controller,
        userData,
        false
      )
    );

    return () => {
      controller.abort();
      dispatch(resetState());
    };
  }, []);




  useEffect(() => {
    if (supportingTable) {
      const allTables = Object.values(supportingTable);
      const lastTable = allTables[allTables.length - 1];
      const created = lastTable?.find((item) => item.IsCreated);

      if (created) {
        setLastCreatedProduct(created);
      }
    }
  }, [supportingTable]);



  useEffect(() => {
    if (updateId !== null) {
      dispatch({
        type: UPDATE_FORM_FIELD,
        payload: itemList.filter((item) => item.ProductId === updateId)[0],
      });
      setEditProduct(
        itemList.filter((item) => item.ProductId === updateId)[0]
      )
      setIsProductUpdate(true);
    }
    setUpdateId(null);
  }, [updateId]);











  const onImageChange = (e) => {
    selectedImgUrl = URL.createObjectURL(e.target.files[0]);
    setImage(e.target.files[0]);
    setImageUrl(selectedImgUrl);
  };




  const handleSearchChange = (data) => {
    dispatch(setSearchFieldValue(data));
  };

  const handleFormChange = (data) => {
    let payload = data;

    if (data.name === "ProductSecondaryCategoryStr") {
      payload = {
        ...data,
        value: Array.isArray(data.value) ? data.value.join(",") : data.value,
      };
    }


    dispatch(setFormFieldValue(payload));
  };




  const closeForm = () => {
    setImage();
    setImageUrl("");
    setEditProduct(null);
    setIsProductUpdate(false);
  };





  const handleProductDetailsChange = (detailsData) => {

    console.log("Details I Recieve In Parent Component", detailsData);

    // Update the form fields with the formatted product details
    dispatch(setFormFieldValue({
      name: 'ProductDetail',
      value: detailsData.ProductDetail
    }));

    dispatch(setFormFieldValue({
      name: 'ProductDetailBranch',
      value: detailsData.ProductDetailBranch
    }));

    dispatch(setFormFieldValue({
      name: 'ProductDetailOrderSource',
      value: detailsData.ProductDetailOrderSource
    }));
  };









  const handleSearchSubmit = (e) => {
    e.preventDefault();

    const payload = {
      OperationId: 1,
      CompanyId: userData.CompanyId,
      UserId: userData.UserId,
      UserIP: "12.1.1.12",
      ...searchFields,
      ProductName: searchFields.ProductName.trim(),
    };

    dispatch(
      setInitialState(
        "/CrudProductMaster",
        payload,
        initialFormValues,
        searchFields,
        controller,
        userData,
        false
      )
    );
  };












  const handleDeleteRow = (id) => {
    // Build plain JSON payload
    const payload = {
      OperationId: 4,
      CompanyId: userData.CompanyId,
      UserId: userData.UserId,
      UserIP: "12.1.1.12",
      ProductId: id,
      ProductDetail: [],
      ProductDetailBranch: [],
      ProductDetailOrderSource: [],
    };

    dispatch(
      deleteRow(
        "/CrudProductMaster",
        payload,        // ← send JSON instead of FormData
        controller,
        userData,
        (data) => {
          // Handle response data
          let tables = data;
          delete tables.Table;
          delete tables.Table1;

          const finalTables = { Table1: tables.Table2 };

          dispatch({
            type: SET_SUPPORTING_TABLE,
            payload: finalTables,
          });
        },
        false
      )
    );
  };










  const handleAfterSubmit = async (dataSet) => {

    try {
      const productId = dataSet?.Table8?.[0]?.ProductId;
      if (!productId) return;
      if (!image) return;

      const imagePayload = new FormData();
      imagePayload.append("OperationId", 3);
      imagePayload.append("CompanyId", userData.CompanyId);
      imagePayload.append("ProductId", productId);
      imagePayload.append("UserId", userData.UserId);
      imagePayload.append("UserIP", "12.1.1.12");
      imagePayload.append("ProductImage", image);

      dispatch(
        submitForm(
          "/CrudProductImage",
          imagePayload,
          initialFormValues,
          controller,
          userData,
          1,
          null,
          true
        )
      );
      message.success("Product image uploaded successfully.");
    } catch (err) {
      console.error("Image upload failed:", err);
      message.error("Failed to upload product image.");
    }
  };



  const handleFormSubmit = (e, id) => {
    e.preventDefault();

    // Create a shallow copy of formFields without ProductImage
    const { ProductImage, ...restFormFields } = formFields;

    const payload = {
      OperationId: id,
      CompanyId: userData.CompanyId,
      UserId: userData.UserId,
      UserIP: "12.1.1.12",
      ...restFormFields,
      SortOrder: Number(formFields.SortOrder) || 0,
      ProductDetail: formFields.ProductDetail || [],
      ProductDetailBranch: formFields.ProductDetailBranch || [],
      ProductDetailOrderSource: formFields.ProductDetailOrderSource || []
    };

    dispatch(
      submitForm(
        "/CrudProductMaster",
        payload,
        initialFormValues,
        controller,
        userData,
        id,
        (dataSet) => {
          handleAfterSubmit(dataSet);
          setResetDetailsTrigger(prev => prev + 1);
        },
        false
      )
    );

    setIsProductUpdate(false);
    setImage(null);
    setImageUrl("");
    closeForm();
  };













  const searchPanel = (
    <Fragment>
      <FormSelect
        colSpan={5}
        listItem={supportingTable.Table1 || []}
        disabled={!supportingTable.Table1}
        idName="CategoryId"
        valueName="CategoryName"
        size={INPUT_SIZE}
        name="ProductCategoryId"
        label="Product Category"
        value={searchFields.ProductCategoryId}
        onChange={handleSearchChange}
      />

      <FormTextField
        colSpan={4}
        label="Product Name"
        name="ProductName"
        size={INPUT_SIZE}
        value={searchFields.ProductName}
        onChange={handleSearchChange}
      />
    </Fragment>
  );

  const formPanel = (
    <Fragment>
      <FormSelect
        colSpan={6}
        listItem={supportingTable.Table1 || []}
        disabled={!supportingTable.Table1}
        idName="CategoryId"
        valueName="CategoryName"
        size={INPUT_SIZE}
        name="ProductCategoryId"
        label="Product Category"
        value={formFields.ProductCategoryId || ""}
        onChange={handleFormChange}
        required={true}
      />

      <FormSelect
        colSpan={6}
        listItem={supportingTable.Table5 || []}
        disabled={!supportingTable.Table5}
        idName="ProductTagId"
        valueName="ProductTag"
        size={INPUT_SIZE}
        name="ProductTagId"
        label="Product Tag"
        value={formFields.ProductTagId || ""}
        onChange={handleFormChange}
      // required={true}
      />

      <FormTextField
        colSpan={6}
        label="Product Name"
        name="ProductName"
        size={INPUT_SIZE}
        value={formFields.ProductName}
        onChange={handleFormChange}
        required={true}
      />

      <FormTextField
        colSpan={6}
        label="Sort Order"
        name="SortOrder"
        size={INPUT_SIZE}
        value={formFields.SortOrder || ""}
        onChange={handleFormChange}
      // required={true}
      />

      <Col span={12} className="flex flex-col">
        <label>Select Multiple Category</label>
        <Select
          mode="multiple"
          showSearch
          colSpan={8}
          className="w-full"
          options={(supportingTable.Table1 || []).map((item) => ({
            label: item.CategoryName,
            value: item.CategoryId, // number
          }))}
          disabled={!supportingTable.Table1}
          value={
            formFields.ProductSecondaryCategoryStr
              ? formFields.ProductSecondaryCategoryStr.split(",").map((id) =>
                Number(id)
              ) // convert back to numbers
              : []
          }
          onChange={(value) =>
            handleFormChange({
              name: "ProductSecondaryCategoryStr",
              value, // this will be array of numbers
            })
          }
        />
      </Col>

      <Col span={12}>
        <div>
          <label>Product Description</label>
          <TextArea
            rows={1}
            placeholder="Enter product Description..."
            name="Description"
            onChange={(event) =>
              handleFormChange({ name: "Description", value: event.target.value })
            }
            value={formFields.Description}
          />
        </div>
      </Col>

      <FormCheckbox
        colSpan={4}
        idName="id"
        valueName="name"
        name="IsEnable"
        label="Is Enabled"
        checked={formFields.IsEnable}
        onChange={handleFormChange}
      />

      {/* <div className="ant-col ant-col-8 mt-5">
        <FormCheckbox
       
          idName="id"
          valueName="name"
          name="DisplayInPos"
          label="Display in Pos"
          checked={formFields.DisplayInPos}
          onChange={handleFormChange}
        />
      </div> */}

      <FormCheckbox
        colSpan={4}
        idName="id"
        valueName="name"
        name="DisplayInWeb"
        label="Display In Web"
        checked={formFields.DisplayInWeb}
        onChange={handleFormChange}
      />



      <FormCheckbox
        colSpan={4}
        idName="id"
        valueName="name"
        name="DisplayInMobile"
        label="Display In Mobile"
        checked={formFields.DisplayInMobile}
        onChange={handleFormChange}

      />



      <div className="w-full  flex items-center gap-10">


        <div className="flex  items-center p-2 gap-3 rounded-lg">

          <img
            src={
              imageUrl !== ""
                ? imageUrl
                : formFields.ProductImage !== ""
                  ? process.env.REACT_APP_BASEURL + formFields.ProductImage
                  : ""
            }
            alt=""
            style={{ width: "200px", height: "auto", objectFit: "cover", borderRadius: "12px" }}
          />

          <div className="flex flex-col gap-2">
            <p>Upload Product Image</p>
            <input type="file" accept="image/*" onChange={onImageChange} />
          </div>



        </div>
      </div>



      <ProductDetailsManager
        supportingTable={supportingTable}
        onDetailsChange={handleProductDetailsChange}
        editProduct={editProduct}
        isProductUpdate={isProductUpdate}
        resetTrigger={resetDetailsTrigger}
      />
    </Fragment>
  );

  return (
    <>
      <BasicFormComponent
        formTitle="Create Product"
        searchPanel={searchPanel}
        formPanel={formPanel}
        searchSubmit={handleSearchSubmit}
        formWidth={"100%"}
        onFormSave={handleFormSubmit}
        onFormClose={closeForm}
        tableRows={itemList}
        tableLoading={tableLoading}
        formLoading={formLoading}
        tableColumn={columns}
        deleteRow={handleDeleteRow}
        actionID="ProductId"
        editRow={setUpdateId}
        fields={initialFormValues}
        lastCreatedProduct={lastCreatedProduct}
      />
    </>
  );
};

export default CreateProduct;
